import { StreamChat } from "stream-chat";
import { ENV } from "../../config/env";

/**
 * HTTP timeout for Stream API calls. The SDK's built-in default is 3 s, which
 * was the app's most frequent error in production ("timeout of 3000ms
 * exceeded", NOMADAS-CHAT-8/7/E/Y) — phones on mobile networks routinely miss
 * it on ordinary channel queries.
 */
const STREAM_HTTP_TIMEOUT_MS = 10000;

let streamClient: StreamChat | null = null;

export function getStreamClient() {
    if (!streamClient) {
        streamClient = StreamChat.getInstance(ENV.STREAM_API_KEY, { timeout: STREAM_HTTP_TIMEOUT_MS });
    }
    return streamClient;
}
